import styles from './reset-password-form.module.scss';
import { Button, FormikTextInputField } from '@spotted-zebra-uk/ui-components';
import { Formik, useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import * as yup from 'yup';
import { useMemo } from 'react';

type ResetPasswordFormProps = {
  submitting: boolean;
  handlePasswordReset: (email: string) => void;
};

export const ResetPasswordForm = ({
  submitting,
  handlePasswordReset,
}: ResetPasswordFormProps) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const initialValues = { email: searchParams.get('email') || '' };

  const validationForm = useMemo(() => {
    return yup.object().shape({
      email: yup
        .string()
        .email(t('forms.emailIsInvalid'))
        .required(t('forms.emailIsInvalid')),
    });
  }, []);

  const onSubmit = (values: { email: string }) => {
    handlePasswordReset(values.email);
  };

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationForm}
    >
      {({ handleSubmit }) => (
        <form onSubmit={e => e.preventDefault()}>
          <FormikTextInputField
            id="email"
            label={t('forms.email')}
            placeholder={t('forms.email')}
            useFormikField={useField}
          />
          <Button
            onClick={() => handleSubmit()}
            fullWidth
            className={styles.submitButton}
            disabled={submitting}
          >
            {t('resetPassword.resetPassword')}
          </Button>
        </form>
      )}
    </Formik>
  );
};
